<template>
  <div id="tool-bar">
    <v-toolbar absolute scroll-off-screen color="white">
      <img :src="domainLogoUrl" class="nav-bar-logo" />

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <v-btn
          v-show="this.$route.meta.loginRequired"
          slot="activator"
          icon
          @click="goHome()"
        >
          <img src="static/icons/home_black.png" width="24" />
        </v-btn>
        <span>{{ $t('message.home') }}</span>
      </v-tooltip>

      <div v-if="this.$store.getters.getAuthenticatedUser">
        <v-menu offset-y>
          <v-tooltip bottom slot="activator">
            <v-btn slot="activator" icon id="more-btn">
              <img src="static/icons/more_horiz_black.png" width="24" />
            </v-btn>
            <span>{{ $t('message.more') }}</span>
          </v-tooltip>
          <v-list>
            <v-list-tile>
              <v-list-tile-title>
                <v-list-tile-title>
                  {{ this.$store.getters.getAuthenticatedUser.email }}
                </v-list-tile-title>
              </v-list-tile-title>
            </v-list-tile>
            <v-divider />
            <v-list-tile @click="promptLogout()">
              <v-list-tile-title>{{ $t('message.logout') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="goContact()">
              <v-list-tile-title>{{
                $t('message.contact.header')
              }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    goHome() {
      if (this.$store.getters.getAuthenticatedUser.admin) {
        this.$router.push('/applicationAdminList')
      } else {
        this.$router.push('/applicationList')
      }
    },
    goContact() {
      this.$router.push('/contact')
    },
    promptLogout() {
      confirm('Are you sure you want to logout?') && this.logout()
    },
    logout() {
      axios.post('/logout')

      //Clear data
      this.$store.dispatch('logout')

      this.$router.push('/')
    }
  },
  computed: {
    domainLogoUrl: function() {
      if (this.$store.getters.getProgram.domain) {
        return require('@/assets/images/' +
          this.$store.getters.getProgram.domain +
          '/domainLogo.png')
      }
      return require('@/assets/images/domainLogo.png')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue